var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7983 8.57734C15.0619 8.31374 15.4893 8.31374 15.7529 8.57734L19.1982 12.0227C19.4618 12.2863 19.4618 12.7136 19.1982 12.9772L15.7529 16.4226C15.4893 16.6862 15.0619 16.6862 14.7983 16.4226C14.5347 16.159 14.5347 15.7316 14.7983 15.468L17.7663 12.5L14.7983 9.53194C14.5347 9.26833 14.5347 8.84095 14.7983 8.57734Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85645 12.5C8.85645 12.1272 9.15865 11.825 9.53145 11.825H18.7189C19.0917 11.825 19.3939 12.1272 19.3939 12.5C19.3939 12.8727 19.0917 13.175 18.7189 13.175H9.53145C9.15865 13.175 8.85645 12.8727 8.85645 12.5Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95645 5.9562H10.8439C11.2167 5.9562 11.5189 5.65399 11.5189 5.2812C11.5189 4.90841 11.2167 4.6062 10.8439 4.6062H4.9377C4.58463 4.6062 4.24602 4.74646 3.99636 4.99612C3.7467 5.24577 3.60645 5.58438 3.60645 5.93745V19.0625C3.60645 19.4155 3.7467 19.7541 3.99636 20.0038C4.24602 20.2534 4.58463 20.3937 4.9377 20.3937H10.8439C11.2167 20.3937 11.5189 20.0915 11.5189 19.7187C11.5189 19.3459 11.2167 19.0437 10.8439 19.0437H4.95645V5.9562Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.48a823dfcf9d0a45b7605ab4e8d726d1.svg";
export { ForwardRef as ReactComponent };